import React from 'react';
import { ClassWizardProvider } from '@/components/class-wizard/ClassWizardContext';
import ClassWizard from '@/components/class-wizard/ClassWizard';
import { 
  GraduationCap, 
  Sparkles, 
  ArrowLeft,
  Calendar,
  Users
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const ClassWizardPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      {/* Modern Header with Gradient Background */}
      <div className="relative overflow-hidden bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-700">
        <div className="absolute inset-0 bg-black/20" />
        <div className="absolute inset-0 bg-gradient-to-br from-white/5 via-transparent to-white/5" />
        
        <div className="relative container mx-auto px-6 py-6 pb-8">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
            <div className="space-y-2">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-white/20 backdrop-blur-sm rounded-lg">
                  <GraduationCap className="h-6 w-6 text-white" />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <h1 className="text-2xl font-extrabold text-white">Assistente de Agendamento de Formação</h1>
                    <div className="flex items-center gap-1 px-2 py-1 bg-white/20 backdrop-blur-sm rounded-full">
                      <Sparkles className="h-3 w-3 text-yellow-300" />
                      <span className="text-xs text-white font-extrabold">Assistente</span>
                    </div>
                  </div>
                  <p className="text-blue-100 text-base pb-2">
                    Crie uma nova classe seguindo os passos do assistente de forma intuitiva
                  </p>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <Button 
                variant="secondary" 
                size="default"
                onClick={() => navigate('/classes')}
                className="backdrop-blur-sm bg-white/20 border-white/30 text-white hover:bg-white/30 transition-all duration-200"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Voltar para Classes
              </Button>
              
              <Button 
                variant="secondary" 
                size="default"
                onClick={() => navigate('/customers')}
                className="backdrop-blur-sm bg-white/20 border-white/30 text-white hover:bg-white/30 transition-all duration-200"
              >
                <Users className="h-4 w-4 mr-2" />
                Gerenciar Clientes
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Content Wrapper */}
      <div className="relative z-10 -mt-4">
        <div className="container mx-auto px-6">
          <div className="bg-white/80 backdrop-blur-sm border-0 shadow-xl rounded-t-2xl min-h-[calc(100vh-200px)]">
            <div className="p-6">
              <ClassWizardProvider>
                <ClassWizard />
              </ClassWizardProvider>
            </div>
          </div>
        </div>
        
        {/* Bottom Spacing */}
        <div className="h-16" />
      </div>
    </div>
  );
};

export default ClassWizardPage; 